import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fade } from "react-awesome-reveal";
import Loader from "react-loaders";
import "./index.scss";
import img1 from "../../assets/images/19198934.jpg";
import img3 from "../../assets/images/20943532.jpg";
import img4 from "../../assets/images/5147533.jpg";
import img2 from "../../assets/images/2683973.jpg";
import img5 from "../../assets/images/websitesymbol.jpg";
import img6 from "../../assets/images/mobdev.jpg";
import img7 from "../../assets/images/seo.jpg";
import img8 from "../../assets/images/sem.jpg";

const Services = () => {
  return (
    <>
      <div className="services-title">
        <h1>Our Services & Features </h1>
      </div>
      <div className="serv-content">
        <div className="panel panel-default" style={{}}>
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img1} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>
              Digital Marketing
            </h1>
            <h3 className="text-serv">
              We use a range of digital marketing services to support your
              campaigns and strategies which will help your company grow and
              improve your bottom line.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img
              style={{
                maxBlockSize: "300px",
                marginTop: "35px",
                marginBottom: "55px",
              }}
              src={img4}
            />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>Printing</h1>
            <h3 className="text-serv">
              We provide a high-quality prints and packaging in no time with
              suitable prices. Our prints include brochures, rollups, identity
              cards, posters, fliers, magazines and catalogs.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img2} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>Branding</h1>
            <h3 className="text-serv">
              Creating an identity is the key. Our company will aid you
              kickstart your business creating a brand identity for your
              company. In no time you will have a position in the market by
              creating your brand logo, symbol and design.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img
              style={{ maxBlockSize: "300px", marginBottom: "5px" }}
              src={img3}
            />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>
              Events Management
            </h1>
            <h3 className="text-serv">
              It is our responsibility to provide you with a range of resources
              and services to plan your upcoming event with the appropriate
              control action.
            </h3>
          </div>
        </div>
      </div>

      <div className="serv-content">
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img5} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>
              Website Development
            </h1>
            <h3 className="text-serv">
              The company is in charge to ensure you have a proper website for
              your business. We promise to create a top-notch website that
              promotes your company and expand your audience.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img6} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>
              Mobile Development
            </h1>
            <h3 className="text-serv">
              We will create an outperforming and engaging app with superior
              functionality to help you stand out among your competitors and
              keeping in touch with your customers.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img7} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>SEO</h1>
            <h3 className="text-serv">
              Achieving a quality and quantity of website traffic is one of our
              duties. Search engine optimization helps increase awareness and
              conversion rates.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img style={{ maxBlockSize: "300px" }} src={img8} />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>SEM</h1>
            <h3 className="text-serv">
              Being on the top of the list is what search engine marketing is
              all about. We will promote your website and mobile application to
              increase its visibility.
            </h3>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body panel2">
            <img
              style={{ maxBlockSize: "300px", marginBottom: "5px" }}
              src={img3}
            />
            <h1 style={{ fontSize: "1.3em", color: "#efc52b" }}>
              Media Production
            </h1>
            <h3 className="text-serv">
              We specialize in sourcing and offering media production services
              including ads, photoshoots, video and photography services and
              motion media production.
            </h3>
          </div>
        </div>
      </div>

      {/* <Loader type='ball-rotate' /> */}
    </>
  );
};
export default Services;
